exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__LoadingWrapper___ST_hK{display:flex;justify-content:center;overflow:hidden;width:100%}", ""]);

// Exports
exports.locals = {
	"LoadingWrapper": "styles__LoadingWrapper___ST_hK"
};